// extracted by mini-css-extract-plugin
export default {"menu":"Sider_menu__9y0Kc"};